<template>
  <div>
    <v-tooltip bottom v-if="showTooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-4"
          fab
          text
          right
          color="error"
          v-on="on"
          v-bind="attrs"
          @click="dialog = true"
        >
          <eva-icon fill="red" name="trash-2-outline"></eva-icon>
        </v-btn>
      </template>
      <span>{{ $t("dss.deleteMedication") }}</span>
    </v-tooltip>
    <div v-else>
       <v-btn
          class="ml-4"
          fab
          text
          right
          color="error"
          @click="dialog = true"
        >
          <eva-icon fill="red" name="trash-2-outline"></eva-icon>
        </v-btn>
    </div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span>
            {{ $ucfirst($t("dss.rejection.whyDidYouRejectTheRecommendation")) }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-row
                v-for="option in options"
                v-bind:key="option.value"
                cols="12"
                align="center"
              >
                <v-checkbox
                  v-model="selected"
                  :label="$ucfirst($t(`medicationRejectionOfGuideline.${option.label}`))"
                  :value="option.value"
                  dense
                  :rules="checkboxRules"
                />
                <v-text-field
                  class="ml-5 mt-5"
                  outlined
                  dense
                  v-if="option.value == 'OTHER'"
                  :disabled="!selected.includes('OTHER')"
                  :label="$ucfirst($t('medicationRejectionOfGuideline.other'))"
                  v-model="otherText"
                ></v-text-field>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5 pr-5">
          <v-spacer></v-spacer>
          <v-btn
            x-large
            text
            @click="dialog = false"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-cancel</v-icon>
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
          <v-btn
            x-large
            text
            @click="saveRejection()"
            :disabled="!valid"
          >
            <v-icon class="mr-2">mdi-content-save-outline</v-icon>
            {{ $ucfirst($t('buttons.save', {catalog: 'app_mobile'})) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

/**
 * Component DSSDecisionRejection.vue
 *
 * @module DSSDecisionRejection
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/DSSDecisionRejection.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DSSDecisionRejection",
  props: {
      medicationRecommendationId: {
        type: String
      },
      showTooltip: {
        type: Boolean
      }
  },
  watch: {
    selected: function () {
      this.$refs.form.validate();
    },
  },
  data: function () {
    return {
      valid: false,
      dialog: false,
      selected: [],
      options: [
        {
          value: 'PATIENT_CLINICAL_STATUS',
          label: 'patientClinicalStatus'
        },
        {
          value: 'DRUG_DRUG_INTERACTION',
          label: 'drugInteraction'
        },
        {
          value: 'SIDE_EFFECTS',
          label: 'sideEffects'
        },
        {
          value: 'FINANCIAL_REIMBURSEMENT',
          label: 'financialReimbursement'
        },
        {
          value: 'PATIENT_PREFERENCES',
          label: 'patientPreferences'
        },
        {
          value: 'ALLERGIES',
          label: 'allergies'
        },
        {
          value: 'LACK_OF_EVIDENCE_IN_LITERATURE',
          label: 'literature'
        },
        {
          value: 'OTHER',
          label: 'other'
        }
      ],
      otherText: null,
      checkboxRules: [
        (v) =>
          v.length > 0 ||
          this.$ucfirst(this.$t("validation.atLeastOneReasonShouldBeSelected")),
      ],
    };
  },
  methods: {
    saveRejection() {
      this.$refs.form.validate();

      this.$emit("rejection", this.selected, this.otherText, this.$props.medicationRecommendationId);
      this.dialog = false;
    },
  },
};
</script>
